export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_TERRA-60X120.68fde0f5.jpg";